module.exports = __webpack_public_path__ + "media/bootstrap-icons/credit-card-2-front-fill-9ce166b3.svg";